import React, { useEffect } from 'react';
import { Box, Toolbar, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Menu from './Menu/Menu';
import { usePerfilPlano } from '../security/usePerfilPlano';

const DRAWER_WIDTH = 280;

export default function AppLayout() {
    // Densidade de notebook do plano (ver index.css): a classe vai no <html> porque o rem
    // é relativo a ele. Sai ao trocar de conta/plano.
    const { densidadeNotebook } = usePerfilPlano();
    useEffect(() => {
        const raiz = document.documentElement;
        raiz.classList.toggle('densidade-notebook', Boolean(densidadeNotebook));
        return () => raiz.classList.remove('densidade-notebook');
    }, [densidadeNotebook]);

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default', overflowX: 'hidden' }}>
            {/* Componente de Navegação (Sidebar + TopBar) */}
            <Menu />

            {/* Área de Conteúdo Principal */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    px: { xs: 0, sm: 3 },
                    py: { xs: 2, sm: 3 },
                    width: { lg: `calc(100% - ${DRAWER_WIDTH}px)` },
                    transition: '0.2s',
                }}
            >
                {/* IMPORTANTE: Este Toolbar vazio funciona como um "spacer"
                   para que o conteúdo não fique escondido debaixo da AppBar fixa.
                */}
                <Toolbar />

                <Container maxWidth="xl" sx={{ mt: 2, pb: 4, px: { xs: 0 } }}>
                    <Outlet />
                </Container>
            </Box>
        </Box>
    );
}
